import { CommonActions } from "common/reducers/common.actions";
import { ThunkResult } from "common/reducers";

export const CommonAsyncActions = {
  setChatHidden:
    (value: boolean): ThunkResult<void> =>
    (dispatch) => {
      try {
        window.localStorage.setItem("chatHidden", String(value));
      } catch {}
      dispatch(CommonActions.setChatHidden(value));
    },

  initChatHidden: (): ThunkResult<void> => (dispatch) => {
    let hidden = false;
    try {
      hidden = window.localStorage.getItem("chatHidden") === "true";
    } catch {}
    dispatch(CommonActions.setChatHidden(hidden));
  },
};
